import React, { createContext, useContext, useMemo } from 'react';
import Hashids from 'hashids';

const hashids = new Hashids('sabari-construction-2025', 8);
const IdEncoderContext = createContext();

export const IdEncoderProvider = ({ children }) => {
  const encodeId = (id) => hashids.encode(id);
  const decodeId = (hash) => hashids.decode(hash)?.[0] || null;
  
  const value = useMemo(() => ({ encodeId, decodeId }), []);
  return (
    <IdEncoderContext.Provider value={value}>
      {children}
    </IdEncoderContext.Provider>
  );
};

export const useIdEncoder = () => useContext(IdEncoderContext);
